import React from 'react';
import { NavLink, Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import itcLogo from '../Navigation/logo.png';
import './TopNav.css';

/**
 * The four store tabs. `end` keeps the Home tab from matching every route, since
 * "/" is a prefix of all of them.
 */
const TABS = [
  { label: 'Home', to: '/', end: true },
  { label: 'Drivers', to: '/Driver' },
  { label: 'Back Seat', to: '/BackSeat' },
  { label: 'Booking', to: '/Booking' },
];

function SearchIcon() {
  return (
    <svg
      className="itcNavSearchIcon"
      width="15"
      height="15"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <circle cx="11" cy="11" r="7" />
      <line x1="21" y1="21" x2="16.65" y2="16.65" />
    </svg>
  );
}

/**
 * Sticky store header: brand mark, the four tabs, and the search field.
 *
 * Search is controlled by the caller so the query can live with the list it
 * filters. Because the tabs are real routes, switching tabs remounts the page
 * and clears its query — which is the specified reset behavior, for free.
 *
 * The admin pages (AdminPage) render this nav with no search handlers: they
 * have no list to filter, and a visible field that filtered nothing would be a
 * dead control. Passing neither prop omits the field entirely.
 */
export default function TopNav({ searchQuery, onSearchChange }) {
  const showsSearch = typeof onSearchChange === 'function';

  return (
    <nav className="itcNav">
      <Link to="/" className="itcNavBrand" aria-label="ITCurves App Store home">
        <img src={itcLogo} alt="" />
      </Link>

      <div className="itcNavTabs">
        {TABS.map((tab) => (
          <NavLink key={tab.to} to={tab.to} end={tab.end} className="itcNavTab">
            {tab.label}
            <span className="itcNavTabUnderline" aria-hidden="true" />
          </NavLink>
        ))}
      </div>

      {showsSearch && (
        <div className="itcNavSearch">
          <SearchIcon />
          <input
            type="text"
            value={searchQuery || ''}
            onChange={(event) => onSearchChange(event.target.value)}
            placeholder="Search companies…"
            aria-label="Search companies"
          />
        </div>
      )}
    </nav>
  );
}

TopNav.propTypes = {
  searchQuery: PropTypes.string,
  onSearchChange: PropTypes.func,
};
